import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Pager, Paging } from "devextreme-react/data-grid";
import 'devextreme-react/text-area';
import { useNavigate } from "react-router-dom";
import AssistitoEditPanel from "./AssistitoEditPanel";
import { useScreenSize } from "../../utils/media-query";


type Props = {
  onHidden?: () => void; 
  readOnly?: boolean;
}

export type AssistitoEditPopupHandle = {
  show: (assistitoId: string, title?:string) => void,
}

type state = {
  assistitoId?: string,
  visible: boolean
}

const AssistitoEditPopup: React.ForwardRefRenderFunction<AssistitoEditPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ assistitoId: undefined, visible: false });
  const [popupTitle, setPopupTitle] = useState<string>("Assistito"); 
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] =useState(isXSmall || isSmall);

  function hide() {
    setState({ assistitoId: undefined, visible: false });
    props.onHidden?.(); 
  }

  useImperativeHandle(ref, () => ({
    show(assistitoId,title) {
      setState({
        assistitoId: assistitoId,
        visible: true
      });
      if (title)
        setPopupTitle(title);
    }
  }));

  return (
    <React.Fragment>
      <Popup
        visible={state.visible}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        fullScreen={fullscreen}
        showTitle={true}
        onHidden={hide}
        title={popupTitle}
        container=".dx-viewport"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
                <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          //visible={!(isXSmall || isSmall)}  
          options={{
            icon: 'fullscreen',
            onClick: () => setFullscreen(!fullscreen) ,
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="center"
          options={{
            text: 'Chiudi',
            onClick: hide,
          }}
        />
        {state.assistitoId &&
          <AssistitoEditPanel assistitoId={state.assistitoId} readOnly={props.readOnly}  />
        }
      </Popup>
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditPopup);
